import {UserDiscardedAdsListValueObject} from '../ValueObjects/UserDiscardedAdsListValueObject.js'
import {UserDiscardedAdsRepository} from './UserDiscardedAdsRepository.js'

export class HttpUserDiscardedAdsRepository extends UserDiscardedAdsRepository {
  #config
  #authenticationFetcher

  static create({config, authenticationFetcher}) {
    return new HttpUserDiscardedAdsRepository({config, authenticationFetcher})
  }

  constructor({config, authenticationFetcher}) {
    super()
    this.#config = config
    this.#authenticationFetcher = authenticationFetcher
  }

  #getBaseUrl({userId}) {
    return `${this.#config.get('API_URL')}/users/${userId}/preferences/discarded/ads`
  }

  async getDiscardedAds({userId}) {
    const response = await this.#authenticationFetcher.get(this.#getBaseUrl({userId}))
    const items = response.data.map(({adId}) => adId)
    return UserDiscardedAdsListValueObject.create({items})
  }

  addDiscardedAd({adId, userId}) {
    return this.#authenticationFetcher.post(this.#getBaseUrl({userId}), {adId: String(adId)})
  }
}
